import React, { FunctionComponent } from 'react';
import useStyles from './BlogHomeBanner.css';
import moment from 'moment';

export const BlogHomeBanner: FunctionComponent<any> = (props) => {
  const date2 = props.bannerData?.date.replace( 'T' , ' ');
  const postDate = moment(date2).format('MMMM D, YYYY');
  const classes= useStyles({imgUrl:props.bannerData?.featuredImage?.node?.sourceUrl});
  return(<>
    <div className={classes.blogsHeaderImgContainer}>
      <div className={classes.blogsHeaderImgDetails}>
        <div className={classes.title}>{props.bannerData?.title}</div>
        <div className={classes.subTitle}>{props.bannerData?.author?.name}, {postDate}</div>
      </div>
    </div>
  </>);
};
